import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAtsReports = createAsyncThunk(
  'reportsv2/ats',
  async (payload = {}, { extra: { http }, rejectWithValue }) => {
    try {
      const result = await http.post('/reports/ats', payload);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAtsReportsDrillDown = createAsyncThunk(
  'reportsv2/atsDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post('/reports/ats/drilldown', payload);
      return result?.data;
    } catch {}
  }
);
